module.exports = __webpack_public_path__ + "static/img/img-pak-fajri.7fe9a9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-pak-fajri.png
// module id = SJqZ
// module chunks = 36